import React from "react";
import { TransferforofficerContainer } from "../../../containers/SupportSystem/SupportForm/TransferforofficerContainer";

export function TransferforofficerPage () {
    return(
        <TransferforofficerContainer/>
    )
}